import React, { Component } from "react";
import { connect } from "react-redux";
import { getUserNameForAvatar, inIframe } from "Utils";
import { updateUsersSettings } from "thunks";
import {
  initSaveUsers,
  setRole,
  setAllowCreateDashboard,
  setAllowAccessToDashboardList,
  setAllowAssociateDashboards,
  setAllowAccessToCollaboratorList,
  setAllowUpdateSlide,
  setAllowCreateSlide,
  setAllowAccessToSlideList,
  setAllowAccessToSettings,
  setAllowUpdateDashboard,
  setSelectedUsers
} from "actions";
import styles from "./Authorizations.local.scss";
import classnames from "classnames";
import _ from "i18n";
import MultiSwitch from "../Common/Switch/MultiSwitch";
import { TTP_API_URL } from "Config";
import Switch from "../Common/Switch/Switch";

class Sidebar extends Component {
  componentDidUpdate(prevProps, prevState) {
    const { selectedUsers, dispatch } = this.props;
    if (
      !!selectedUsers &&
      selectedUsers.length !== 0 &&
      prevProps.selectedUsers !== selectedUsers
    ) {
      if (selectedUsers.length > 1) {
        // Gestion de la multi select

        let roles = [];
        // eslint-disable-next-line array-callback-return
        selectedUsers.map((item, i) => {
          let role = item.dataAuthorization.role
            ? item.dataAuthorization.role
            : "NONE";
          if (!roles.includes(role)) {
            roles.push(role);
          }
        });

        let withoutPreferences = true;
        let allowCreation = false;
        let allowAccess = false;
        let allowAssociate = false;
        let allowAccessCollaborator = false;
        let allowAccessSlide = false;
        let allowCreationSlide = false;
        let allowUpdateSlide = false;
        let allowUpdateDashboard = false;
        let allowAccessToSettings = false;

        if (roles.length === 1) {
          roles = roles[0];
          if (roles === "MANAGER") {
            const authorisations = selectedUsers[0].dataAuthorization;
            withoutPreferences = false;
            // eslint-disable-next-line array-callback-return
            selectedUsers.map((item, i) => {
              if (
                JSON.stringify(item.dataAuthorization.preferences) !==
                JSON.stringify(authorisations.preferences)
              ) {
                withoutPreferences = true;
                return false;
              }
            });

            allowCreation = !(
              withoutPreferences ||
              authorisations.preferences.allowCreateDashboard === 0
            );
            allowAccess = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessToDashboardList === 0
            );
            allowAssociate = !(
              withoutPreferences ||
              authorisations.preferences.allowAssociateDashboards === 0
            );
            allowAccessCollaborator = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessToCollaboratorList === 0
            );
            allowAccessSlide = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessToSlideList === 0
            );
            allowCreationSlide = !(
              withoutPreferences ||
              authorisations.preferences.allowCreateSlide === 0
            );
            allowUpdateSlide = !(
              withoutPreferences ||
              authorisations.preferences.allowUpdateSlide === 0
            );
            allowUpdateDashboard = !(
              withoutPreferences ||
              authorisations.preferences.allowUpdateDashboard === 0
            );
            allowAccessToSettings = !(
              withoutPreferences ||
              authorisations.preferences.allowAccessToSettings === 0
            );
          }
        }

        dispatch(setAllowCreateDashboard(allowCreation));
        dispatch(setAllowAccessToDashboardList(allowAccess));
        dispatch(setAllowAssociateDashboards(allowAssociate));
        dispatch(setAllowAccessToCollaboratorList(allowAccessCollaborator));
        dispatch(setAllowUpdateSlide(allowUpdateSlide));
        dispatch(setAllowUpdateDashboard(allowUpdateDashboard));
        dispatch(setAllowAccessToSlideList(allowAccessSlide));
        dispatch(setAllowCreateSlide(allowCreationSlide));
        dispatch(setAllowAccessToSettings(allowAccessToSettings));
        dispatch(setRole(roles));
      } else {
        // just one selected user

        const authorisations = selectedUsers[0].dataAuthorization;
        let withoutPreferences = !authorisations || !authorisations.preferences;

        const selectedRole = authorisations.role ? authorisations.role : "NONE";
        const allowCreationDashboard = !(
          withoutPreferences ||
          Number(authorisations.preferences.allowCreateDashboard) === 0
        );
        const allowAccessDashboard = !(
          withoutPreferences ||
          Number(authorisations.preferences.allowAccessToDashboardList) === 0
        );
        const allowAssociateDashboard = !(
          withoutPreferences ||
          Number(authorisations.preferences.allowAssociateDashboards) === 0
        );
        const allowAccessCollaborator = !(
          withoutPreferences ||
          Number(authorisations.preferences.allowAccessToCollaboratorList) === 0
        );
        const allowAccessSlide = !(
          withoutPreferences ||
          Number(authorisations.preferences.allowAccessToSlideList) === 0
        );
        const allowCreationSlide = !(
          withoutPreferences ||
          Number(authorisations.preferences.allowCreateSlide) === 0
        );
        const allowUpdateSlide = !(
          withoutPreferences ||
          Number(authorisations.preferences.allowUpdateSlide) === 0
        );
        const allowUpdateDashboard = !(
          withoutPreferences ||
          Number(authorisations.preferences.allowUpdateDashboard) === 0
        );
        const allowAccessToSettings = !(
          withoutPreferences ||
          Number(authorisations.preferences.allowAccessToSettings) === 0
        );

        dispatch(setAllowCreateDashboard(allowCreationDashboard));
        dispatch(setAllowAccessToDashboardList(allowAccessDashboard));
        dispatch(setAllowAssociateDashboards(allowAssociateDashboard));
        dispatch(setAllowAccessToCollaboratorList(allowAccessCollaborator));
        dispatch(setAllowUpdateSlide(allowUpdateSlide));
        dispatch(setAllowUpdateDashboard(allowUpdateDashboard));
        dispatch(setAllowCreateSlide(allowCreationSlide));
        dispatch(setAllowAccessToSlideList(allowAccessSlide));
        dispatch(setAllowAccessToSettings(allowAccessToSettings));
        dispatch(setRole(selectedRole));
      }
    }
  }

  init() {
    this.props.dispatch(initSaveUsers());
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    this.props.dispatch(setSelectedUsers([]));
    this.props.handleSettingsTab(false);
  }

  handleCancel = () => {
    this.props.handleSettingsTab(false);
    this.props.dispatch(setSelectedUsers([]));
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    document.body.classList.remove("hidden_overflow");
  };

  saveUsersSettings() {
    this.props.dispatch(updateUsersSettings()).then(res => {
      this.handleCancel();
    }, err => err);
  }

  renderSingleUser(user) {
    const {
      firstName,
      lastName,
      avatar,
      avatarUrl,
      role,
      dataAuthorization
    } = user;

    let avatarDiv = null;
    if (avatarUrl !== undefined) {
      avatarDiv = (
        <div
          className={styles.user_avatar}
          style={{ backgroundImage: `url(${avatarUrl})` }}
        />
      );
    } else if (avatar) {
      avatarDiv = (
        <div
          className={styles.user_avatar}
          style={{ backgroundImage: `url(${TTP_API_URL}/${avatar})` }}
        />
      );
    } else {
      avatarDiv = (
        <div className={classnames(styles.user_avatar, "empty-avatar")}>
          <span>{getUserNameForAvatar(firstName, lastName)}</span>
        </div>
      );
    }

    let signatureDiv = [];
    signatureDiv.push(<h3 key="sh3">{firstName + " " + lastName}</h3>);
    if (role && role.id !== undefined) {
      signatureDiv.push(<h4 key="sh4">{_(role.type)}</h4>);
    }
    signatureDiv.push(
      <h5 key="h5">
        {/*@todo to delete this dump test for translation purpose */}
        {dataAuthorization && dataAuthorization.role !== undefined
          ? dataAuthorization.role === "MANAGER"
            ? _("MANAGER")
            : _(dataAuthorization.role)
          : "____"}
      </h5>
    );
    return (
      <div className={classnames(styles.user, styles.sidebar__user)}>
        {avatarDiv}
        <div className={styles.user_header}>{signatureDiv}</div>
      </div>
    );
  }

  renderGroupUsers(users) {
    let avatarsDiv = [];
    let names = [];

    for (let i = 0; i < users.length; i++) {
      if (i >= 3) {
        break;
      }
      let { id, firstName, lastName, avatar, avatarUrl } = users[i];

      names.push(users.length <= 3 ? firstName + " " + lastName : firstName);
      if (avatarUrl) {
        avatarsDiv.push(
          <div
            key={`user-${id}`}
            className={styles.user_avatar}
            style={{ backgroundImage: `url(${avatarUrl})` }}
          />
        );
      } else if (avatar) {
        avatarsDiv.push(
          <div
            key={`user-${id}`}
            className={styles.user_avatar}
            style={{ backgroundImage: `url(${TTP_API_URL}/${avatar})` }}
          />
        );
      } else {
        avatarsDiv.push(
          <div
            key={`user-${id}`}
            className={classnames(styles.user_avatar, "empty-avatar")}
          >
            <span>{getUserNameForAvatar(firstName, lastName)}</span>
          </div>
        );
      }
    }
    let other = 0;
    if (users.length > 3) {
      other = users.length - 3;
    }
    return (
      <div className={styles.side__bar_group}>
        <div className={styles.side__bar_group_avatar}>{avatarsDiv}</div>
        <div className={styles.side__bar_group_names}>
          {names.join(users.length <= 3 ? _(" and ") : ", ")}
          {other > 0 ? (
            <span>
              {" "}
              {_(" and ")}{" "}
              <strong>
                {other} {_("Other user(s)")}.
              </strong>
            </span>
          ) : null}
        </div>
      </div>
    );
  }

  renderUsers() {
    const { selectedUsers } = this.props;

    if (!selectedUsers || selectedUsers.length === 0) {
      return null;
    }

    if (selectedUsers.length === 1) {
      return this.renderSingleUser(selectedUsers[0]);
    } else {
      return this.renderGroupUsers(selectedUsers);
    }
  }

  setRoleValue(val) {
    this.props.dispatch(setRole(val));
  }

  setAllowCreateDashboard(allowCreation) {
    this.props.dispatch(setAllowCreateDashboard(allowCreation));
  }

  setAllowUpdateDashboard(allowCreation) {
    this.props.dispatch(setAllowUpdateDashboard(allowCreation));
  }

  setAllowAccessToDashboardList(allowAccess) {
    this.props.dispatch(setAllowAccessToDashboardList(allowAccess));
  }

  setAllowAssociateDashboards(allowAssociate) {
    this.props.dispatch(setAllowAssociateDashboards(allowAssociate));
  }
  setAllowAccessToCollaboratorList(allowAssociate) {
    this.props.dispatch(setAllowAccessToCollaboratorList(allowAssociate));
  }
  setAllowUpdateSlide(allowAssociate) {
    this.props.dispatch(setAllowUpdateSlide(allowAssociate));
  }

  setAllowCreateSlide(allowAssociate) {
    this.props.dispatch(setAllowCreateSlide(allowAssociate));
  }

  setAllowAccessToSlideList(allowAssociate) {
    this.props.dispatch(setAllowAccessToSlideList(allowAssociate));
  }

  setAllowAccessToSettings(allowAssociate) {
    this.props.dispatch(setAllowAccessToSettings(allowAssociate));
  }

  renderPrivilegesBlock() {
    const {
      role,
      allowCreateDashboard,
      allowAccessToDashboardList,
      allowAssociateDashboards,
      allowAccessToCollaboratorList,
      allowAccessToSlideList,
      allowCreateSlide,
      allowAccessToSettings,
      allowUpdateDashboard,
      allowUpdateSlide
    } = this.props;

    if (role === "MANAGER") {
      // if (role === "COLLABORATOR" || role === "SUPERVISOR") {
      return (
        <div>
          <div className={styles.line} />
          <div className={styles.separator}>{_("Privilèges du dashboard")}</div>
          <div className={styles.preferences_switch}>
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccessDashboard")}</span>
              <Switch
                name="accessDashboardList"
                keyAttr="access-dashboard-list"
                isChecked={allowAccessToDashboardList}
                onChange={val => this.setAllowAccessToDashboardList(val)}
              />
            </div>
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowCreateDashboard")}</span>
              <Switch
                name="dashboardCreate"
                keyAttr="dashboard-create"
                isChecked={allowCreateDashboard}
                onChange={val => this.setAllowCreateDashboard(val)}
              />
            </div>
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowUpdateDashboard")}</span>
              <Switch
                name="dashboardUpdate"
                keyAttr="dashboard-create"
                isChecked={allowUpdateDashboard}
                onChange={val => this.setAllowUpdateDashboard(val)}
              />
            </div>
            <div className={styles.preferences_switch}>
              <div className={"switch"}>
                <span className="sidebar_role">
                  {_("allowAssociateDashboards")}
                </span>
                <Switch
                  name="associateDashboards"
                  keyAttr="sms-create"
                  isChecked={allowAssociateDashboards}
                  onChange={val => this.setAllowAssociateDashboards(val)}
                />
              </div>
            </div>
          </div>

          {/*<div className={styles.separator}>{_("associate privileges")}</div>*/}
          <div className={styles.line} />
          <div className={styles.separator}>
            {_("Privilèges des Collaborateurs")}
          </div>
          <div className={styles.preferences_switch}>
            <div className={"switch"}>
              <span className="sidebar_role">
                {_("allowAccessCollaborator")}
              </span>
              <Switch
                name="associateDashboards"
                keyAttr="sms-create"
                isChecked={allowAccessToCollaboratorList}
                onChange={val => this.setAllowAccessToCollaboratorList(val)}
              />
            </div>
          </div>
          <div className={styles.line} />
          <div className={styles.separator}>{_("Privilèges des slides")}</div>
          <div className={styles.preferences_switch}>
            <div className={"switch"}>
              <span className="sidebar_role">
                {_("allowAccessSlide")}
                {/*{_("Allow access to slides list")}*/}
              </span>
              <Switch
                name="associateDashboards"
                keyAttr="sms-create"
                isChecked={allowAccessToSlideList}
                onChange={val => this.setAllowAccessToSlideList(val)}
              />
            </div>
            <div className={"switch"}>
              <span className="sidebar_role">
                {_("allowCreateSlide")}
                {/*{_("Allow create slide")}*/}
              </span>
              <Switch
                name="dashboardCreate"
                keyAttr="dashboard-create"
                isChecked={allowCreateSlide}
                onChange={val => this.setAllowCreateSlide(val)}
              />
            </div>
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowUpdateSlide")}</span>
              <Switch
                name="dashboardCreate"
                keyAttr="dashboard-create"
                isChecked={allowUpdateSlide}
                onChange={val => this.setAllowUpdateSlide(val)}
              />
            </div>
          </div>
          <div className={styles.line} />
          <div className={styles.separator}>{_("parameterPrivileges")}</div>
          <div className={styles.preferences_switch}>
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccessParameters")}</span>
              <Switch
                name="dashboardCreate"
                keyAttr="dashboard-create"
                isChecked={allowAccessToSettings}
                onChange={val => this.setAllowAccessToSettings(val)}
              />
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  render() {
    const { fetched, updating, role, settingsIsActive } = this.props;
    if (!fetched) {
      return null;
    }
    return (
      <div>
        <div
          id="settings__sidebar"
          className={classnames(
            styles.sidebar,
            settingsIsActive ? styles.display : "",
            inIframe() ? styles.inIframe : ""
          )}
        >
          <img
            src={"/img/icons/close.svg"}
            className={classnames(
              styles.sidebar__close,
              inIframe() ? styles.inIframe : ""
            )}
            onClick={() => this.handleCancel()}
            alt={""}
          />
          {this.renderUsers()}
          {/*<div className={styles.separator}>{_("role")}</div>*/}
          <div className={styles.switches}>
            <MultiSwitch
              labels={[
                _("NONE"),
                _("MANAGER"),
                _("COLLABORATOR"),
                _("SUPERVISOR")
              ]}
              selectedValue={role}
              vals={["NONE", "MANAGER", "COLLABORATOR", "SUPERVISOR"]}
              name="dashboardRole"
              onChange={val => this.setRoleValue(val)}
              customClass="sidebar_role"
            />
          </div>
          {this.renderPrivilegesBlock()}

          <div className={styles.actions_block}>
            <button
              className={styles.cancel_btn}
              onClick={() => this.handleCancel()}
            >
              {_("cancel")}
            </button>
            <button
              className={styles.save_button}
              disabled={Array.isArray(role)}
              onClick={() => this.saveUsersSettings()}
            >
              <img
                src={"/img/icons/tail-spin.svg"}
                alt={""}
                className={updating ? styles.loading : ""}
              />
              {_("save")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  role: state.authorizationsSettings.role,
  selectedUsers: state.authorizationsSettings.selectedUsers,
  users: state.authorizations.items,
  fetched: state.authorizations.fetched,
  updating: state.authorizations.updating,
  updated: state.authorizations.updated,
  allowCreateDashboard: state.authorizationsSettings.allowCreateDashboard,
  allowAccessToDashboardList:
    state.authorizationsSettings.allowAccessToDashboardList,
  allowAssociateDashboards:
    state.authorizationsSettings.allowAssociateDashboards,
  allowAccessToCollaboratorList:
    state.authorizationsSettings.allowAccessToCollaboratorList,
  allowAccessToSlideList: state.authorizationsSettings.allowAccessToSlideList,
  allowCreateSlide: state.authorizationsSettings.allowCreateSlide,
  allowUpdateSlide: state.authorizationsSettings.allowUpdateSlide,
  allowUpdateDashboard: state.authorizationsSettings.allowUpdateDashboard,
  allowAccessToSettings: state.authorizationsSettings.allowAccessToSettings
});

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Authorizations/SideBar.js